const MessagesTypes = Object.freeze({
  APP_MESSAGE: 0,
  CALL_MESSAGE: 1
})

export default {
  state: {
    messages: []
  },
  mutations: {
    pushMessage(state, message) {
      state.messages = [...state.messages, message]
    },
    popMessage(state, id) {
      state.messages = state.messages.filter(el => el.id != id)
    }
  },
  actions: {
    async throwMessage({commit}, { type, message_data, message_class, resolver }) {
      let id = Math.random() * 999999999999999

      let resolve = async (data) => {
        if (resolver) {
          await resolver(id, data)
        }

        await commit('popMessage', id)
      }

      await commit('pushMessage', {
        id,
        type,
        message_data,
        message_class,
        resolve
      })

      return resolve
    },
    async throwTimeoutMessage({dispatch}, { type=MessagesTypes.APP_MESSAGE, message_data, message_class, resolver, timeout = 5000}) {
      let resolve = await dispatch('throwMessage', {type, message_data, message_class, resolver})

      return new Promise(r => setTimeout(() => {resolve(); r();}, timeout))
    }
  },
  getters: {
    messages(state){
      return state.messages
    }
  }
}